import useUrlState from "@ahooksjs/use-url-state";
import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
} from "react";

interface ViewSwitchContextProps {
  view: "my" | "employees";
  setViewState: (view: "my" | "employees") => void;
}

export const ViewSwitchContext = createContext<
  ViewSwitchContextProps | undefined
>(undefined);

export const ViewSwitchProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [view, setView] = useUrlState({ view: "my" });
  const setViewState = useCallback(
    (view: "my" | "employees") => setView({ view }),
    [setView],
  );

  const value = useMemo(
    () => ({ view: view.view, setViewState }),
    [view.view, setViewState],
  );

  return (
    <ViewSwitchContext.Provider value={value}>
      {children}
    </ViewSwitchContext.Provider>
  );
};

export const useViewSwitchContext = () => {
  const context = useContext(ViewSwitchContext);
  if (!context) {
    throw new Error(
      "useViewSwitchContext must być używany wewnątrz ViewSwitchProvider"
    );
  }

  return context;
};
